import {OutgoingCreateListElementType, OutgoingCreateType} from "../interface";
import {invDetailInit} from "../../../inv/detail/state";
import moment from "moment";

export const outgoingCreateInit: OutgoingCreateType = {
    accountName: "",
    changeAt: moment().format("YYYY-MM-DD"),
    code: "",
    createEachOutgoingReqList: [],
    memo: ""
}

export const outgoingCreateListElementInit: OutgoingCreateListElementType = {
    ...invDetailInit,
    changeAmount: 0,
    inventoryId: 0
}